import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TopBar from 'components/TopBar/TopBar';
import MainNav from 'components/MainNav/MainNav';
import MainContent from 'components/MainContent/MainContent';
import Preloader from 'components/Preloader/Preloader';
import ProcessingOrder from 'components/ProcessingOrder/ProcessingOrder';
import Modal from 'components/Modal/Modal';
import QuickMessages from 'components/QuickMessages/QuickMessages';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchSession } from 'redux/modules/session';
import { Redirect } from 'react-router-dom';
import { identify, getTrackingOptions } from 'lib/Segment/helpers';
import i18n from 'i18n/i18n';
import { getRoute, SUBSCRIPTION_SUCCESSFUL, ROOT, USERS, XC_PLUS, SUBSCRIPTION } from 'routes';
import ERROR from 'errors/errorids';
import { fetchMlsBoards, getConnectionList, getAgentMlsIds } from 'redux/modules/mls';
import {
	changeCompanyAndNotify,
	connectCompanySocketEvents,
	fetchCompaniesIndustries,
	fetchCompaniesSizes,
	fetchUserRegion,
	fetchCompaniesCountries,
	getActiveCompanyId,
	resolveActiveCompanyId,
	getUpcomingInvoiceEstimate
} from 'redux/modules/companies';

import {
	resolveMLsUiType
} from 'redux/modules/mls';

import {
	getDesktopAppFlag,
	setDesktopUserFlag,
	setDesktopTrialFlag,
	setReAccessNoIndustry,
	setUpgradePopupFlag,
	setPendingTriggerCheckout,
	setCouponIdProvidedFlag,
	setPerpetuallAppFlag,
	setPlusOverviewPageVisited,
	setPerpetualOverviewPageVisited	
} from 'redux/modules/app';
import { 
	connectUserSocketEventProviderChange,
	connectUserSocketEventLogout
} from 'redux/modules/account';
import { connectWorkspacesSocketEvents } from 'redux/modules/workspaces';
import { showPreloader, hidePreloader } from 'redux/modules/preloader';
import { showChargebeeLoader, hideChargebeeLoader } from 'redux/modules/chargebeeLoader';
import { bindActionCreators } from 'redux';
import {
	XC_URL,
	BACK_TO_PARAM,
	ASK_FOR_COMPANY_PARAM,
	SKIP_ONBOARDING_PARAM,
	PERIOD_PARAM,
	DESKTOP_APPLICATION_PARAM,
	UPGRADE_POPUP_PARAM,
	REAL_ESTATE_PLAN_PARAM,
	IS_REAL_ESTATE_POPUP,
	APP_COMPANY_ID_PARAM,
	PRODUCT_NAME_PARAM,
	PRODUCT_QUANTITY_PARAM,
	XC_USER_FOUND,
	PRODUCT_LANGUAGE_PARAM,
	CURRENCY_PARAM,
	CAP_KEY,
	ONBOARDING_KEY,
	PLUS_OVERVIEW_PLAN_ID,
	PERPETUAL_OVERVIEW_PLAN_ID,
	MAGIX_SERIAL_PARAM,
	REACTIVATE_PARAM,
	MAGIX_EMAIL_PARAM,
	MAGIX_CATEGORY_PARAM,
	COUPON_ID_PARAM,
	SERIAL_NUMBER_REGEXP,
	DISCOUNT_KEY,
	USER_ROLE_ADMIN,
	SUBSCRIPTION_PLAN,
	EXTERNAL_REDIRECT_PARAM,
	INTERNAL_REDIRECT_PARAM,
	PRODUCT_SOURCE_PARAM,
	COUPON_TYPE,
	MAXIC_DISCOUNT_PROD_TYPE,
	PACKAGES_HIDE_SIDEBAR_BREAKPOINT,
	REAL_ESTATE_INDUSTY_ID,
	MLS_UI
} from 'config';
import { showModal } from 'redux/modules/modal';
import classNames from 'classnames';
import { topBarHeight, mainNavWidth } from 'theme/uiConfig';
import _ from 'lodash';
import AppContext from './AppContext';
import { isAdmin, isGuest, isTempCompany } from 'utils/state';
import {
	getCheckoutPlan,
	saveIsReUpgradePopupFlag,
	clearIsReUpgradePopupFlag,
	saveIsDesktopTrial,
	getIsDesktopTrial,
	getIsReAccessNoIndustry,
	saveIsReAccessNoIndustry,
	clearIsReAccessNoIndustry
} from 'utils/storage';
import { parseQuery } from 'utils/url';
import { 
	trackRouteMagixDiscount,
	trackRouteUpgradePopupDiscount,
	trackRouteRealEstatePlanPopup,
	trackRouteCouponDiscount,
	trackRouteDesktopAppUpgrade,
	trackRouteSource
} from 'lib/Segment/customTrackers';
import 'redux/modules/apistatustester';
import { 
	getCurrentPlanId,
	convertPlanIdIntoSubscription,
	isPerpetualPlan,
	getMembersPaidQuantity,
	getSubscriptionsAndAddons,
	isPerpetualOwner,
	isDesktopTrial,
	isReAccessNoIndustry
} from '../../utils/subscription';
import {
	filterNonGuestUsers
} from '../../utils/users';
import { setupLogger } from '../../logger/logger';
import Logger from '../../logger/logger';
import AppError from '../../errors/apperror';
import HttpError from '../../errors/httperror';
import isEmail from 'validator/lib/isEmail';
import { checkCrsCredentials, saveTakeOverCredentials } from 'redux/modules/crs';
import { applyDiscountUsingCouponSetId, applyDiscountUsingCouponId, applyMagixDiscount } from 'redux/modules/discount';

const log = Logger.get('App');

const styles = theme => ({
	root: {
		position: 'relative',
		display: 'flex',
		width: '100%',
		height: '100vh',
	},
	topBarPadding: {
		paddingTop: topBarHeight
	},
	content: {
		flexGrow: 1,
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		marginLeft: `-${mainNavWidth}px`,
		overflow: 'auto'
	},
	contentShift: {
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginLeft: 0,
	},
	maxWidth: {
		width: '100%',
	}
});

@withStyles(styles)
class App extends Component {

	constructor(props) {
		super(props);

		this.handleWindowResizeDebounced = _.debounce(this.handleWindowResize.bind(this), 500);

		this.toggleNav = this.toggleNav.bind(this);
		this.scrollContentToTop = this.scrollContentToTop.bind(this);
		this.setMainRef = this.setMainRef.bind(this);
		this.redirectToXC = this.redirectToXC.bind(this);
		this.main = null;

		let isConfirmedSubscription = false;
		let isInitialSubscription = false;
		let isPerpetualSubscription = false;
		let subscriptionId = null;
		let cid = null;
		let realEstatePlan = null;
		let productName = null;
		let magixCat = null;
		let askForCompany = null;
		let isDiscountTakeoverFromWebsite = false;
		let redirectRoute = null;
		let showInvalidQueryPlanIdMessage;
		let isCBPlanExternalRedirect;
		let isCBPlanInternalRedirect;
		let productQuantity;
		let productSource;
		let productPeriod;
		let reactivateSubscription;

		const queryParams = parseQuery(props.location.search);
		if (queryParams['confirm-subscription'] === 'true') {
			isConfirmedSubscription = true;
			const savedCheckoutPlanId = getCheckoutPlan();
			if (savedCheckoutPlanId) {
				if (isPerpetualPlan(savedCheckoutPlanId)) {
					isPerpetualSubscription = true;
				} else {
					isInitialSubscription = true;
				}
				
			}

			// remove query parameters from the hash
			subscriptionId = queryParams['subscription-id'];
			window.location.hash = window.location.hash.split('?')[0];
		}
		if (queryParams['cid']) {
			cid = queryParams['cid'];
		}

		if (queryParams[REAL_ESTATE_PLAN_PARAM]) {
			realEstatePlan = queryParams[REAL_ESTATE_PLAN_PARAM];
		}		

		if (queryParams[IS_REAL_ESTATE_POPUP]) {
			saveIsReUpgradePopupFlag(true);
		} else {
			clearIsReUpgradePopupFlag();
		}

		if (queryParams['prod']) {
			productName = queryParams['prod'];

			if (['XPL', 'XWDL', 'XPGDL'].includes(productName.toUpperCase())) {
				this.props.setPerpetuallAppFlag(true);
			}
		}

		if (queryParams[REACTIVATE_PARAM]) {
			reactivateSubscription = true;
		}

		if (queryParams['source']) {
			productSource = queryParams['source'];
		}
		if (queryParams['period']) {
			productPeriod = queryParams['period'];
		}
		if (queryParams['quantity']) {
			productQuantity = queryParams['quantity'];
		}
		if (queryParams['pcat']) {
			magixCat = queryParams['pcat'];
		}		

		if (queryParams['select-company']) {
			askForCompany = queryParams['select-company'];
		}

		// remove some query params from URL
		
		if (queryParams[REACTIVATE_PARAM] || queryParams[REAL_ESTATE_PLAN_PARAM] || queryParams[IS_REAL_ESTATE_POPUP] ||
			queryParams[DESKTOP_APPLICATION_PARAM] || this.props.isDesktopApp || productSource ||
			this.props.isDiscountTakeoverFromWebsite || this.props.isUpgradePopup || this.props.isCouponIdProvided) {

			if (queryParams[DESKTOP_APPLICATION_PARAM] || this.props.isDesktopApp) {
				this.props.setDesktopUserFlag(true);
			}

			if (this.props.isDiscountTakeoverFromWebsite) {
				isDiscountTakeoverFromWebsite = true;
			}

			if (this.props.isUpgradePopup) {
				this.props.setUpgradePopupFlag(true);
			}

			if (this.props.isCouponIdProvided) {
				this.props.setCouponIdProvidedFlag(true);
			}

			const queryParamsCleaned = [];
			if (!_.isEmpty(queryParams)) {
				Object.keys(queryParams).forEach(key => {
					if (key === PRODUCT_QUANTITY_PARAM ||
						key === PRODUCT_SOURCE_PARAM ||
						key === DESKTOP_APPLICATION_PARAM ||
						key === UPGRADE_POPUP_PARAM ||
						key === IS_REAL_ESTATE_POPUP ||
						key === REAL_ESTATE_PLAN_PARAM ||
						key === COUPON_ID_PARAM ||
						key === REACTIVATE_PARAM ||
						key === ASK_FOR_COMPANY_PARAM ||
					(this.isPlusOverview &&
					[MAGIX_SERIAL_PARAM, MAGIX_EMAIL_PARAM, MAGIX_CATEGORY_PARAM].includes(key))
					) return;

					queryParamsCleaned.push(`${key}=${queryParams[key]}`);
				});
			}

			window.location.hash = window.location.hash.split('?')[0] + this.flattenQueryParams(queryParamsCleaned);
		}

		if (isDiscountTakeoverFromWebsite && this.isPlusOverview) {
			const magixSerial = queryParams.pserial && window.atob(queryParams.pserial);
			const magixEmail = queryParams.pemail && window.atob(queryParams.pemail);
			if (magixSerial &&
				magixEmail &&
				isEmail(magixEmail) &&
				SERIAL_NUMBER_REGEXP.test(magixSerial)) {
				this.props.saveTakeOverCredentials(magixEmail, magixSerial);
				this.props.checkCrsCredentials(
					magixEmail,
					magixSerial,
					_.get(this.props.user, 'mainEmail'),
					MAXIC_DISCOUNT_PROD_TYPE.SUBSCRIPTION
				);
			}
		}

		const cbPlanId = queryParams['chargebee-plan-id'];
		
		if (props.isCbPlanProvided && cbPlanId) {

			if (cbPlanId.indexOf('plus-overview') !== -1 ||
			cbPlanId.indexOf('perpetual-overview') !== -1 ||
			cbPlanId.indexOf('real-estate-overview') !== -1 ||
			cbPlanId.indexOf('standard-overview') !== -1) {
				isCBPlanInternalRedirect = true;
			} else if (Object.values(SUBSCRIPTION_PLAN).includes(cbPlanId.split('-')[0])) {
				isCBPlanExternalRedirect = true;
			} else {
			
				redirectRoute = SUBSCRIPTION;
				showInvalidQueryPlanIdMessage = true;
			}
		}

		if (queryParams[EXTERNAL_REDIRECT_PARAM]) {
			isCBPlanExternalRedirect = true;
		}				

		if (queryParams[INTERNAL_REDIRECT_PARAM]) {
			isCBPlanInternalRedirect = true;
		}				

		this.state = {
			loading: true,
			navOpen: true,
			hasCompany: false,
			companyFoundInSession: false,
			isInitialSubscription,
			isConfirmedSubscription,
			isPerpetualSubscription,
			askForCompany,
			isDiscountTakeoverFromWebsite,
			isCBPlanExternalRedirect,
			isCBPlanInternalRedirect,
			isCbPlanProvided: props.isCbPlanProvided,
			subscriptionId,
			cid,
			realEstatePlan,
			productName,
			productSource,
			productPeriod,
			productQuantity,
			magixCat,
			redirectRoute,
			showInvalidQueryPlanIdMessage,
			redirectToXC: null,
			reloadApp: props.reloadApp,
			cbPlanId,
			externalDiscountApplied: false,
			reactivateSubscription
		};
	}

	setMainRef(element) {
		this.main = element;
	}

	componentWillMount() {
		this.props.fetchSession()
			.then(data => {
				if (data.result) {
					// Update current language to user settings language
					const serverLanguage = _.get(data, 'result.user.settings.language');
					if (serverLanguage && serverLanguage !== window.localStorage.getItem('lang')) {
						window.localStorage.setItem('lang', serverLanguage);
						if (this.props.originalHash || this.props.originalSearch) {
							let newLocation = this.props.originalHash || this.props.originalSearch;

							if (newLocation.indexOf('?') === -1) {
								newLocation += '?ts=' + new Date().getTime();
							} else {
								newLocation += '&ts=' + new Date().getTime();
							}

							window.location.href = newLocation;
							window.location.reload();

						} else {
							window.location.href = '?ts=' + new Date().getTime();
						}
					}

					const companyId = resolveActiveCompanyId(true);
					const isPayingCompany = _.get(this.props, 'companies.byId[' + companyId + '].hasActiveSubscription');
					setupLogger(this.props.user, companyId, isPayingCompany);

					const company = data.result.companies.find(company => company._id === companyId);
					if (company && company.displayName) {
						document.title = 'Xara Workspace | ' + company.displayName;
					}
					
					this.props.getActiveCompanyId();
					this.props.getDesktopAppFlag();
					this.props.changeCompanyAndNotify();
					this.props.connectCompanySocketEvents();
					this.props.connectUserSocketEventProviderChange();
					this.props.connectUserSocketEventLogout();
					this.props.connectWorkspacesSocketEvents();
					this.props.fetchCompaniesIndustries();
					this.props.fetchCompaniesSizes();
					this.props.fetchUserRegion();
					this.props.fetchCompaniesCountries();
					this.props.fetchMlsBoards();
					this.props.resolveMLsUiType();
					this.props.hidePreloader();
					
					const userInfo = {
						email: _.get(this.props.user, 'mainEmail'),
						name: _.get(this.props.user, 'name')
					};

					identify(userInfo, getTrackingOptions(this.props.company));

				} else {
					if (data instanceof AppError) {
						const firstMessage = data.getMesageFromHistoryAtIndex(0);
						if (firstMessage instanceof HttpError && firstMessage.status === 403) {
							const trackingId = localStorage.getItem('ajs_user_id');

							if (trackingId && trackingId !== 'null' && !trackingId.match(/^"[a-f\d]{24}"$/i)) {
								window.analytics && window.analytics.reset && window.analytics.reset();
								window.Intercom && window.Intercom('shutdown');
								// Give Segment and Intercom the time to clear cookies and localstorage before redirecting
								setTimeout(() => this.setState({ redirectToXC: true }), 1000);
							} else {
								this.setState({ redirectToXC: true });
							}
						}
					}
				}
			});
	}

	toggleNav() {
		this.setState({ navOpen: !this.state.navOpen });
	}

	hideNav() {
		this.setState({ navOpen: false });
	}

	showNav() {
		this.setState({ navOpen: true });
	}

	componentWillReceiveProps(nextProps) {
		const { selectedId, rawDataById, allIds } = nextProps.companies;
		const allRawIds = rawDataById ? Object.keys(rawDataById) : [];

		const { errorId, isGuest, reloadApp } = nextProps;
		const { loading, externalDiscountApplied } = this.state;	

		if (!externalDiscountApplied) {
			if (this.state.isDiscountTakeoverFromWebsite &&
				this.isPlusOverview &&
				this.props.crs.areCredentialsValid !== nextProps.crs.areCredentialsValid &&
				nextProps.crs.areCredentialsValid === true &&
				this.props.modalShown === false) {
				this.props.applyMagixDiscount(
					nextProps.crs.takeoverMagixEmail,
					nextProps.crs.takeoverProductSerial,
					nextProps.crs.prodCatOfLastValidCombination, 
					nextProps.crs.tierOfLastValidCombination,
					MAXIC_DISCOUNT_PROD_TYPE.SUBSCRIPTION
				);

				trackRouteMagixDiscount(nextProps.crs.prodCatOfLastValidCombination, getTrackingOptions(this.props.company));
				this.setState({ externalDiscountApplied: true });

			} else if (this.props.app.isUpgradePopup && this.isStandardProductOverview &&
				!nextProps.discount.isDiscountApplied) {
				this.props.applyDiscountUsingCouponSetId(DISCOUNT_KEY.UPGRADE_POPUP);
				this.setState({ externalDiscountApplied: true });

			} else if (selectedId && this.props.app.isCouponIdProvided &&
				(this.isStandardProductOverview || this.isPlusOverview || this.isPerpetualOverview) &&
				this.props.discount.pendingRequest === null
			) {
				if (!this.state.isCBPlanExternalRedirect) {
					this.props.applyDiscountUsingCouponId(
						this.state.cid,
						this.isPerpetualOverview ? COUPON_TYPE.LICENSES : COUPON_TYPE.SEATS,
						true);
				}
				this.setState({ externalDiscountApplied: true });
			}
		}

		if (nextProps.paymentRedirectUrl) {
			// This is charbee redirect url in format https://xara-test.chargebee.com/pages/v3/ID/
			window.location = nextProps.paymentRedirectUrl;
			return;
		}

		if (this.props.company && this.state.productQuantity && this.state.productSource === 'pricing') {

			if (this.props.selectedCompanyId) {
				const isPayingCompany = _.get(this.props,
					'companies.byId[' + this.props.selectedCompanyId + '].hasActiveSubscription');

				if (!isPayingCompany) {
					const nonGuestUsers = filterNonGuestUsers(this.props.company.users);
					if (nonGuestUsers.length > this.state.productQuantity) {
						this.setState({ productQuantity: nonGuestUsers.length });
					}
				}
			}
		}

		if (errorId) {
			this.props.showModal('ERROR_MODAL');
		} else if (loading && reloadApp) {
			// Reload app on error
			if (allIds.length > 1) {
				this.props.showModal('COMPANY_SELECTION_MODAL', { redirectURL: ROOT });
			} else {
				window.location.href = window.location.origin + ROOT.replace(':companyId', '#' + resolveActiveCompanyId(false));
			}
		} else if (isGuest) {
			this.props.showModal('GUEST_MODAL');
		} else if (!this.state.redirectRoute) {
			this.renderUpgradePopup();
		}

		if (allRawIds) {
			// There are companies returned by session, but user could not have admin/member permission to any of them.
			// We get selectedId using getActiveCompanyId and initializeFromSession, selectedId might be defined or not but
			// we also check if companyId is not found in session to offer user to switch accounts
			this.setState({
				reloadApp: false,
				loading: false,
				hasCompany: !!selectedId,
				companyFoundInSession: allRawIds.includes(selectedId)
			});

			if (!loading && !allRawIds.includes(selectedId)) {
				const nError = new AppError({
					message: 'Company not found in session in App.js',
					errorId: ERROR.UNKNOWN,
					visualisers: { feature: 'APP' },
					errorDetails: {
						allRawIds,
						selectedId,
						resolvedActiveCompanyId: resolveActiveCompanyId(true)
					}
				});
				log.send(nError);
			}
		}
	}

	componentDidUpdate(prevProps) {
		const { redirectRoute, isConfirmedSubscription } = this.state;
		const { selectedCompanyId } = this.props;
		if (this.props.location.pathname !== prevProps.location.pathname) {
			this.scrollContentToTop();
			this.handleWindowResizeDebounced();
		}

		if (selectedCompanyId) {
			if (!redirectRoute && isConfirmedSubscription) {
				this.setState({
					redirectRoute: SUBSCRIPTION_SUCCESSFUL, 
					isInitialSubscription: false,
					isConfirmedSubscription: false,
					isPerpetualSubscription: false 
				});
			}

			if (redirectRoute && (this.isSubscriptionSuccessView || this.isStandardProductOverview)) {
				this.setState({ redirectRoute: null, showInvalidQueryPlanIdMessage: null });
			}

			if (this.props.selectedPlanId && this.props.isAdmin &&
				!_.get(getSubscriptionsAndAddons(this.props.company), 'subscription.cancellationPending') &&
				!this.props.companies.upcomingInvoiceEstimationXhrInProgress &&
				!this.props.company.hasUnlimitedTeamSubscription &&

				(
					!this.props.companies.getUpcomingInvoiceErorId 
					||
					(this.props.companies.getUpcomingInvoiceErorId !== ERROR.OFFLINE &&
						this.props.companies.getUpcomingInvoiceErorId !== ERROR.API_REQUEST_LIMIT_EXCEEDED)					
				) &&

				(getMembersPaidQuantity(this.props.company) !== getMembersPaidQuantity(prevProps.company) ||
				(_.get(getSubscriptionsAndAddons(prevProps.company), 'subscription.cancellationPending') &&
					!_.get(getSubscriptionsAndAddons(this.props.company), 'subscription.cancellationPending')) ||
				this.props.selectedPlanId !== prevProps.selectedPlanId)
			) {
				this.props.getUpcomingInvoiceEstimate();
			}
		}

		if (this.isPlusOverview && !this.props.app.wasPlusOverviewPageVisited) {
			this.props.setPlusOverviewPageVisited();
		} else if (this.isPerpetualOverview && !this.props.app.wasPerpetualOverviewPageVisited) {
			this.props.setPerpetualOverviewPageVisited();
		}

		if (this.props.company && this.props.app.isDesktopTrial === null) {
			const desktopFlagValue = 
			
			// check first in session storage
			getIsDesktopTrial() ||
			
			// then check query params
			isDesktopTrial(
				this.props.company.hasTrial || !this.props.company.isActive,
				this.props.isDesktopApp || this.props.app.isDesktopApp,
				this.state.productName,
				this.state.cbPlanId,
				this.props.user.originId
			);

			if (desktopFlagValue) {
				saveIsDesktopTrial(true);
			}

			this.props.setDesktopTrialFlag(desktopFlagValue);			
		}

		if (this.props.company &&
			this.props.company.industryId &&
			this.props.company.industryId !== REAL_ESTATE_INDUSTY_ID &&
			this.props.app.isReAccessNoIndustry) {
			clearIsReAccessNoIndustry();
			this.props.setReAccessNoIndustry(false);
		}

		if (this.props.mls.mlsUiType === MLS_UI.SELF_CONNECT_API) {

			if (!this.props.mls.getConnectionsSuccess &&
				!this.props.mls.getConnectionsInProgress &&
				!this.props.mls.getConnectionsErrorId) {
				this.props.getConnectionList();
			}

			if (!this.props.mls.getAgentsMlsIdsSuccess &&
				!this.props.mls.getAgentsMlsIdsInProgress &&
				!this.props.mls.getAgentsMlsIdsErrorId) {
				this.props.getAgentMlsIds();
			}
		}

		if (this.props.company && this.props.app.isReAccessNoIndustry === null) {
			const reAccessNoIndustryValue = 
			
			// check first in session storage
			// then check query params
			getIsReAccessNoIndustry() ||
			isReAccessNoIndustry(
				this.props.company.industryId,
				this.props.company.hasTrial || !this.props.company.isActive,
				this.state.productName,
				this.state.cbPlanId
			);
		
			if (reAccessNoIndustryValue) {
				saveIsReAccessNoIndustry(true);
			}
			this.props.setReAccessNoIndustry(reAccessNoIndustryValue);			
		}		

		if (this.props.company &&
			_.get(prevProps.company, 'industryId') &&
			_.get(this.props.company, 'industryId') !== _.get(prevProps.company, 'industryId')) {
			this.props.resolveMLsUiType();
		}
	}

	componentDidMount() {
		
		if (this.props.isUpgradePopup && this.isStandardProductOverview) {
			trackRouteUpgradePopupDiscount(getTrackingOptions(this.props.company));
		} else if (this.props.isReUpgradePopup) {
			trackRouteRealEstatePlanPopup(this.state.realEstatePlan, getTrackingOptions(this.props.company));

		} else if (this.state.cid &&
			(this.isStandardProductOverview || this.isPlusOverview || this.isPerpetualOverview)) {
			trackRouteCouponDiscount(this.state.cid, getTrackingOptions(this.props.company));
		} else if ((this.isPlusOverview || this.isPerpetualOverview) &&
			this.state.productName &&
			(this.props.isDesktopApp || this.props.app.isDesktopApp)) {
			trackRouteDesktopAppUpgrade(this.state.productName, getTrackingOptions(this.props.company));
		} else if (this.state.productName && this.state.productSource &&
			(this.isStandardProductOverview || this.isPlusOverview || this.isPerpetualOverview)) {
			trackRouteSource(this.state.productName, this.state.productSource, getTrackingOptions(this.props.company));
		}

		if (this.isPlusOverview) {
			this.props.setPlusOverviewPageVisited();
		} else if (this.isPerpetualOverview) {
			this.props.setPerpetualOverviewPageVisited();
		}

		window.addEventListener('resize', this.handleWindowResizeDebounced);
		this.handleWindowResizeDebounced();

		document.querySelector('html').setAttribute('lang', i18n.getCurrentLanguage(false));
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleWindowResizeDebounced);
	}

	scrollContentToTop() {
		this.main && (this.main.scrollTop = 0);
	}

	redirectToXC() {
		const { isDesktopApp } = this.props.app;
		const urlParams = [];

		const queryParams = parseQuery(this.props.location.search);

		const addSkipOnboardingParam = queryParams[SKIP_ONBOARDING_PARAM] === '1';
		if (addSkipOnboardingParam || isDesktopApp) {
			urlParams.push(`${SKIP_ONBOARDING_PARAM}=1`);
		}

		const planId = queryParams['chargebee-plan-id'];
		const pathArray = this.locationPathArray;

		let showComponent = pathArray[1] ? `/${pathArray[1]}` : '/';
		if (pathArray[1] === SUBSCRIPTION.replace('/:companyId/', '') && pathArray.length >= 3) {
			showComponent += `/${pathArray[2]}`;

			if (pathArray.length === 4) {
				//accept currency
				showComponent += `/${pathArray[3]}`;
			}
		}
		urlParams.push(`${BACK_TO_PARAM}=${encodeURIComponent(showComponent)}`);
		
		// Add plan ID
		planId && urlParams.push(`chargebee-plan-id=${planId}`);

		// Add company ID
		if (isDesktopApp) {
			urlParams.push(`${APP_COMPANY_ID_PARAM}=${pathArray[0]}`);
		}

		const productName = queryParams[PRODUCT_NAME_PARAM];
		if (productName) {
			urlParams.push(`${PRODUCT_NAME_PARAM}=${productName}`);
		}

		const productSource = queryParams[PRODUCT_SOURCE_PARAM];
		if (productSource) {
			urlParams.push(`${PRODUCT_SOURCE_PARAM}=${productSource}`);
		}

		const productPeriod = queryParams[PERIOD_PARAM];
		if (productPeriod) {
			urlParams.push(`${PERIOD_PARAM}=${productPeriod}`);
		}		

		const productQuantity = this.state.productQuantity;
		if (productQuantity) {
			urlParams.push(`${PRODUCT_QUANTITY_PARAM}=${productQuantity}`);
		}

		const prodLang = queryParams[PRODUCT_LANGUAGE_PARAM];
		if (prodLang) {
			urlParams.push(`${PRODUCT_LANGUAGE_PARAM}=${prodLang}`);
		}

		const magixSerial = queryParams[MAGIX_SERIAL_PARAM];
		if (magixSerial) {
			urlParams.push(`${MAGIX_SERIAL_PARAM}=${magixSerial}`);
		}

		const magixEmail = queryParams[MAGIX_EMAIL_PARAM];
		if (magixEmail) {
			urlParams.push(`${MAGIX_EMAIL_PARAM}=${magixEmail}`);
		}

		const magixCat = queryParams[MAGIX_CATEGORY_PARAM];
		if (magixCat) {
			urlParams.push(`${MAGIX_CATEGORY_PARAM}=${magixCat}`);
		}

		const couponId = queryParams[COUPON_ID_PARAM];
		if (couponId) {
			urlParams.push(`${COUPON_ID_PARAM}=${couponId}`);
		}

		const xcUserFound = queryParams[XC_USER_FOUND];
		if (xcUserFound) {
			urlParams.push(`${XC_USER_FOUND}=${xcUserFound}`);
		}

		const currency = queryParams[CURRENCY_PARAM];
		if (currency) {
			urlParams.push(`${CURRENCY_PARAM}=${currency}`);
		}

		/* Forward UTM params to XC which might be coming from noticeboard or email campaigns */
		const utm_source = parseQuery(this.props.location.search)['utm_source'];
		if (utm_source) {
			urlParams.push(`utm_source=${encodeURIComponent(utm_source)}`);
		}
		const utm_medium = parseQuery(this.props.location.search)['utm_medium'];
		if (utm_medium) {
			urlParams.push(`utm_medium=${encodeURIComponent(utm_medium)}`);
		}
		const utm_campaign = parseQuery(this.props.location.search)['utm_campaign'];
		if (utm_campaign) {
			urlParams.push(`utm_campaign=${encodeURIComponent(utm_campaign)}`);
		}
		const utm_content = parseQuery(this.props.location.search)['utm_content'];
		if (utm_content) {
			urlParams.push(`utm_content=${encodeURIComponent(utm_content)}`);
		}
		const utm_term = parseQuery(this.props.location.search)['utm_term'];
		if (utm_term) {
			urlParams.push(`utm_term=${encodeURIComponent(utm_term)}`);
		}

		const redirectURL = urlParams.length ?
			`${XC_URL}?${urlParams.join('&')}`
			: `${XC_URL}`;

		window.location.href = redirectURL;
	}

	render() {
		const { classes, isAdmin, isTempCompany, preloader, chargebeeLoader, selectedCompanyId, errorId } = this.props;
		const { redirectRoute, redirectToXC, navOpen } = this.state;
		if (redirectToXC) {
			this.redirectToXC();
		}

		if (selectedCompanyId &&
			redirectRoute &&
			!this.isSubscriptionSuccessView && !(this.isStandardProductOverview && this.state.showInvalidQueryPlanIdMessage)) {
			// Redirect to /#subscription-successful page after purchase
			return (<Redirect 
				to={{
					pathname: getRoute(redirectRoute, selectedCompanyId),
					state: { showInvalidQueryPlanIdMessage: this.state.showInvalidQueryPlanIdMessage }
				}}			
			/>);
		}

		const { isDesktopApp } = this.props.app;
		const onBoarding = this.shouldStartOnBoarding;
		let shouldRenderNav;

		if (!errorId) {
			if (chargebeeLoader.loading) {
				return <ProcessingOrder />;
			}

			if (preloader.loading) {
				return <Preloader />;
			}
		}

		shouldRenderNav = this.shouldRenderNavigation();

		const contentClasses = classNames(classes.content, {
			[classes.maxWidth]: !shouldRenderNav,
			[classes.contentShift]: navOpen
		});

		return (
			<AppContext.Provider value={this.appContext}>
				<div className={classNames(classes.root, shouldRenderNav && classes.topBarPadding)}>
					{shouldRenderNav && <TopBar navOpen={navOpen} navToggle={this.toggleNav} onBoardingEnabled={onBoarding} />}
					{shouldRenderNav
						&& <MainNav
							productName={this.state.productName}
							isDesktopApp={isDesktopApp}
							isPerpetualOwner={isPerpetualOwner(this.props.company)}
							navOpen={navOpen}
							disabled={onBoarding}
							isAdmin={isAdmin}
							isTempCompany={isTempCompany} />}
					<main className={contentClasses} ref={this.setMainRef}>
						{this.renderContent()}
					</main>
					<Modal />
					<QuickMessages />
				</div>
			</AppContext.Provider>
		);
	}

	renderUpgradePopup() {
		const { askForCompany, isConfirmedSubscription } = this.state;
		const searchQuery = parseQuery(this.props.location.search);
		let planId = searchQuery['chargebee-plan-id'];
		let currency = searchQuery['currency'];
		const productName = searchQuery['prod'];
		const productLang = searchQuery['lang'];
		const magixEmail = searchQuery['pemail'];
		const magixSerial = searchQuery['pserial'];
		const magixCat = searchQuery['pcat'];
		const productSource = searchQuery['source'] || this.state.productSource;
		const productQuantity = searchQuery['quantity'] || this.state.productQuantity;
		const pathArray = this.locationPathArray;

		if (!planId &&
			!this.state.isInitialSubscription &&
			!parseQuery(this.props.location.search)['company-known']) {

			// There is no props.match available outside of Router, so we have to manually detect
			// plus-overview route and currency from url like
			// CAP_URL/#62daae6a61ad68e6caab4339/subscription/plus-overview/eur

			if (this.props.location.pathname.indexOf(PLUS_OVERVIEW_PLAN_ID) !== -1) {
				planId = PLUS_OVERVIEW_PLAN_ID;
			
				if (pathArray[pathArray.length-1] !== PLUS_OVERVIEW_PLAN_ID) {
					currency = pathArray[pathArray.length-1];
				}
			} else if (this.props.location.pathname.indexOf(PERPETUAL_OVERVIEW_PLAN_ID) !== -1) {
				planId = PERPETUAL_OVERVIEW_PLAN_ID;

				if (pathArray[pathArray.length-1] !== PERPETUAL_OVERVIEW_PLAN_ID) {
					currency = pathArray[pathArray.length-1];
				}
			}
		}

		let pathRedirectRoute;
		if (pathArray[1] === USERS.replace('/:companyId/', '')) {
			pathRedirectRoute = USERS;
		} else if (pathArray[1] === XC_PLUS.replace('/:companyId/', '')) {
			pathRedirectRoute = XC_PLUS;
		}

		if (pathRedirectRoute && askForCompany) {
			const { rawDataById } = this.props.companies;

			const adminOfCompanies = rawDataById
				?
				Object.values(rawDataById)
					.filter(company => [USER_ROLE_ADMIN].includes(company.userRole))
				:
				[];

			if (adminOfCompanies.length > 1) {
				this.props.showModal('COMPANY_SELECTION_MODAL', { redirectURL: pathRedirectRoute });
			}
		}

		// Take currency from existing plan (as it can't be changed), 
		// otherwise from URL (for plus-overview package), defaults to USD
		if (!_.get(this.props.location, 'state.isCouponMissmatchRedirect') &&
			planId &&
			this.hasCompany &&
			this.isCompanyFoundInSession &&
			!this.props.isGuest &&
			!isConfirmedSubscription) {
			this.props.showModal('UPGRADE_COMPANY_MODAL',
			{
				planId,
				currency,
				isDesktopApp: this.props.isDesktopApp || this.props.app.isDesktopApp,
				productName,
				productLang,
				magixSerial,
				magixEmail,
				magixCat,
				couponId: this.state.cid,
				productPeriod: this.state.productPeriod,
				isUpgradePopup: this.props.app.isUpgradePopup,
				realEstatePlan: this.state.realEstatePlan,
				isCBPlanExternalRedirect: this.state.isCBPlanExternalRedirect,
				isCBPlanInternalRedirect: this.state.isCBPlanInternalRedirect,
				productQuantity,
				productSource
			});
		}
	}

	renderContent() {
		if (this.hasCompany && !this.props.isGuest) {
			// show content only for guests
			const { selectedPlanId } = this.props;
			const activeSubscription = convertPlanIdIntoSubscription(selectedPlanId);
			const { plan } = activeSubscription;
			return (<MainContent
				isRealEstateIndustry={_.get(this.props.company, 'industryId') === REAL_ESTATE_INDUSTY_ID}
				agentsMlsIds={this.props.mls.agentsMlsIds}
				mlsUiType={this.props.mls.mlsUiType}
				isReAccessNoIndustry={this.props.app.isReAccessNoIndustry}
				isPerpetualOwner={isPerpetualOwner(this.props.company)}
				navOpen={this.state.navOpen}
				isCBPlanInternalRedirect={this.state.isCBPlanInternalRedirect}
				isCBPlanExternalRedirect={this.state.isCBPlanExternalRedirect}
				cbPlanId={this.state.cbPlanId}
				plan={plan}
				selectedId={this.props.companies.selectedId}
				isCompanyFoundInSession={this.isCompanyFoundInSession}
				isDesktopApp={this.props.app.isDesktopApp}
				couponId={this.state.cid}
				realEstatePlan={this.state.realEstatePlan}
				productPeriod={this.state.productPeriod}
				isDiscountTakeoverFromWebsite={this.props.isDiscountTakeoverFromWebsite}
				productName={this.state.productName}
				productSource={this.state.productSource}
				productQuantity={this.state.productQuantity}
				isUpgradePopup={this.props.app.isUpgradePopup}
				magixCat={this.state.magixCat}
				isAdmin={this.props.isAdmin}
				isTempCompany={this.props.isTempCompany}
				subscriptionId={this.state.subscriptionId}
				reactivateSubscription={this.state.reactivateSubscription}
				onBoarding={this.shouldStartOnBoarding} />);
		}
	}

	flattenQueryParams(params) {
		let result = '';
		if (params.length) {
			result = '?';
			result += params.join('&');
		}
		return result;
	}

	get isPlusOverview() {
		return this.props.location.pathname.indexOf(PLUS_OVERVIEW_PLAN_ID) !== -1;
	}

	get isPerpetualOverview() {
		return this.props.location.pathname.indexOf(PERPETUAL_OVERVIEW_PLAN_ID) !== -1;
	}

	get isStandardProductOverview() {
		const pathArray = this.locationPathArray;

		const nextPath = pathArray[2] || '';
		return pathArray[1] === SUBSCRIPTION.replace('/:companyId/', '') &&
			nextPath.indexOf('plus-overview') === -1 &&
			nextPath.indexOf('perpetual-overview') === -1 &&
			nextPath.indexOf('monthly') === -1 &&
			nextPath.indexOf('annual') === -1;
	}

	get isSubscriptionSuccessView() {
		return this.props.location.pathname.indexOf('subscription-successful') !== -1;
	}

	shouldRenderNavigation() {
		return this.hasCompany &&
		this.isCompanyFoundInSession &&
		!this.props.isGuest &&
		!this.isSubscriptionSuccessView;
	}

	handleWindowResize() {
		const viewPortWidth = document && window && Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		if (viewPortWidth <= PACKAGES_HIDE_SIDEBAR_BREAKPOINT) {
			const pathArray = this.locationPathArray;
			if (pathArray[1] === SUBSCRIPTION.replace('/:companyId/', '') && this.state.navOpen) {
				this.hideNav();
			} 
		} else {
			this.showNav();
		}
	}	

	get hasCompany() {
		return this.state.hasCompany;
	}

	get isCompanyFoundInSession() {
		return this.state.companyFoundInSession;
	}

	get shouldStartOnBoarding() {
		// [P9052-11082] Disable the onboarding.
		return false;
	}

	get appContext() {
		return {
			navOpen: this.state.navOpen,
			scrollContentToTop: this.scrollContentToTop
		};
	}

	get locationPathArray() {
		const pathArray = [];
		this.props.location.pathname.split('/').forEach(path => {
			if (path) {
				// remove "" from array
				pathArray.push(path);
			}
		});
		return pathArray;
	}
}

App.propTypes = {
	classes: PropTypes.object,
	onBoardingSettings: PropTypes.object,
	fetchSession: PropTypes.func,
	changeCompanyAndNotify: PropTypes.func,
	companies: PropTypes.object,
	location: PropTypes.object,
	history: PropTypes.object,
	errorId: PropTypes.number,
	showModal: PropTypes.func,
	connectCompanySocketEvents: PropTypes.func,
	connectUserSocketEventProviderChange: PropTypes.func,
	connectUserSocketEventLogout: PropTypes.func,
	fetchCompaniesIndustries: PropTypes.func,
	fetchCompaniesSizes: PropTypes.func,
	fetchMlsBoards: PropTypes.func,
	getConnectionList: PropTypes.func,
	getAgentMlsIds: PropTypes.func,
	fetchUserRegion: PropTypes.func,
	fetchCompaniesCountries: PropTypes.func,
	connectWorkspacesSocketEvents: PropTypes.func,
	resolveMLsUiType: PropTypes.func,
	getActiveCompanyId: PropTypes.func,
	getDesktopAppFlag: PropTypes.func,
	setPerpetuallAppFlag: PropTypes.func,
	setPlusOverviewPageVisited: PropTypes.func,
	setPerpetualOverviewPageVisited: PropTypes.func,
	setDesktopUserFlag: PropTypes.func,
	setDesktopTrialFlag: PropTypes.func,
	setReAccessNoIndustry: PropTypes.func,
	setUpgradePopupFlag: PropTypes.func,
	setPendingTriggerCheckout: PropTypes.func,
	setCouponIdProvidedFlag: PropTypes.func,
	isAdmin: PropTypes.bool,
	isGuest: PropTypes.bool,
	isTempCompany: PropTypes.bool,
	preloader: PropTypes.object,
	showPreloader: PropTypes.func,
	hidePreloader: PropTypes.func,
	setupLogger: PropTypes.func,
	processingOrder: PropTypes.object,
	chargebeeLoader: PropTypes.object,
	showChargebeeLoader: PropTypes.func,
	hideChargebeeLoader: PropTypes.func,
	selectedPlanId: PropTypes.string,
	paymentRedirectUrl: PropTypes.string,
	redirectRoute: PropTypes.element,
	selectedCompanyId: PropTypes.string,
	reloadApp: PropTypes.bool,
	isDesktopApp: PropTypes.bool,
	isDiscountTakeoverFromWebsite: PropTypes.bool,
	isCbPlanProvided: PropTypes.bool,
	productName: PropTypes.string,
	productSource: PropTypes.string,
	isUpgradePopup: PropTypes.bool,
	isReUpgradePopup: PropTypes.bool,
	isCouponIdProvided: PropTypes.bool,
	checkCrsCredentials: PropTypes.func.isRequired,
	saveTakeOverCredentials: PropTypes.func.isRequired,
	crs: PropTypes.object.isRequired,
	discount: PropTypes.object.isRequired,
	app: PropTypes.object.isRequired,
	applyMagixDiscount: PropTypes.func,
	applyDiscountUsingCouponSetId: PropTypes.func,
	applyDiscountUsingCouponId: PropTypes.func,
	modalShown: PropTypes.bool,
	originalSearch: PropTypes.string,
	originalHash: PropTypes.string,
	company: PropTypes.object,
	match: PropTypes.object.isRequired,
	getUpcomingInvoiceEstimate: PropTypes.func.isRequired,
	user: PropTypes.object,
	mls: PropTypes.object,
};

App.defaultProps = {
	classes: {}
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById ? state.companies.rawDataById[state.companies.selectedId] : null,
	errorId: state.error.errorId,
	companies: state.companies,
	onBoardingSettings: _.get(state.session, `user.settings.${CAP_KEY}.${ONBOARDING_KEY}`),
	isAdmin: isAdmin(state),
	isGuest: isGuest(state),
	isTempCompany: isTempCompany(state),
	preloader: state.preloader,
	processingOrder: state.processingOrder,
	chargebeeLoader: state.chargebeeLoader,
	selectedCompanyId: state.companies.selectedId,
	selectedPlanId: state.companies.rawDataById ?
		getCurrentPlanId(state.companies.rawDataById[state.companies.selectedId]) : null,
	paymentRedirectUrl: state.companies.paymentRedirectUrl,
	modalShown: state.modal.modalShown,
	crs: state.crs,
	app: state.app,
	discount: state.discount,
	user: _.get(state.session, 'user'),
	mls: state.mls
});

const mapDispatchToProps = dispatch => bindActionCreators({
	fetchSession,
	changeCompanyAndNotify,
	showModal,
	connectCompanySocketEvents,
	connectUserSocketEventProviderChange,
	connectUserSocketEventLogout,
	fetchCompaniesIndustries,
	fetchMlsBoards,
	fetchCompaniesSizes,
	fetchUserRegion,
	fetchCompaniesCountries,
	resolveMLsUiType,
	getActiveCompanyId,
	getDesktopAppFlag,
	setPerpetuallAppFlag,
	setPlusOverviewPageVisited,
	setPerpetualOverviewPageVisited,	
	setDesktopUserFlag,
	setDesktopTrialFlag,
	setReAccessNoIndustry,
	setUpgradePopupFlag,
	setPendingTriggerCheckout,
	setCouponIdProvidedFlag,
	connectWorkspacesSocketEvents,
	showPreloader,
	hidePreloader,
	showChargebeeLoader,
	hideChargebeeLoader,
	checkCrsCredentials,
	saveTakeOverCredentials,
	applyMagixDiscount,
	applyDiscountUsingCouponSetId,
	applyDiscountUsingCouponId,
	getUpcomingInvoiceEstimate,
	getConnectionList,
	getAgentMlsIds
}, dispatch);

export default withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(App));


// WEBPACK FOOTER //
// ./src/containers/App/App.js